import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_URL } from "../services/api";
import { useGetPagination } from "../services/GetService";
import Key from "../util/Key";
import SendMail, { OpenMail, ErrorMail } from "./innerComponent/FormInfo";
const Details = () => {
    const { slug } = useParams();
    const [paginate, setPaginate] = useState(`${API_URL}forms/company/${slug}`);

    const [forms, setForms] = useGetPagination(paginate);

    const cleanPagination = (data) => {
        if (data === "&laquo; Previous") {
            data = "Previous";
        }
        if (data === "Next &raquo;") {
            data = "Next";
        }
        return data;
    };
    return (
        <div className="container">
            <table className="table  caption-top  ">
                <thead>
                    <tr>
                        <th scope="col">N°</th>
                        <th scope="col">Empresa</th>
                        <th scope="col">Nombre</th>
                        <th scope="col">Enviados</th>
                        <th scope="col">Vistos</th>
                        <th scope="col">Errores</th>
                        <th scope="col">Url</th>
                    </tr>
                </thead>
                <tbody>
                    {forms.data &&
                        forms.data.map((form) => {
                            return (
                                <tr key={Key()}>
                                    <td>{form.id}</td>
                                    <td>{form.company.name}</td>
                                    <td>{form.name}</td>
                                        <SendMail id={form.id} />

                                    <td>{form.form_code}</td>
                                </tr>
                            );
                        })}
                </tbody>
            </table>

            <nav aria-label="Page navigation">
                <ul className="pagination d-flex justify-content-end">
                    {forms.data &&
                        forms.links.map((link) => (
                            <li
                                key={link.label}
                                className={`page-item ${
                                    link.active ? "active" : ""
                                }`}
                            >
                                <a
                                    className="page-link"
                                    key={link.url}
                                    onClick={() => {
                                        link.url !== null &&
                                            setPaginate(link.url);
                                    }}
                                >
                                    {cleanPagination(link.label)}
                                </a>
                            </li>
                        ))}
                </ul>
            </nav>
        </div>
    );
};

export default Details;
